var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackupcodes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 63,
    viewBox: "0 0 40 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 23.6147C38 23.6147 38.0247 10.1904 25.4417 6.55226C25.4417 6.55226 12.0433 3.14994 5.728 13.2349L1.93176 11.3865L4.99826 21.3397L14.7337 18.0421L11.9449 16.4309C11.9449 16.4309 15.3663 10.9599 24.42 13.3772C24.42 13.3772 31.1373 15.5099 31.5754 23.6147",
    fill: "#F2FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23.6147C38 23.6147 38.0247 10.1904 25.4417 6.55226C25.4417 6.55226 12.0433 3.14994 5.728 13.2349L1.93176 11.3865L4.99826 21.3397L14.7337 18.0421L11.9449 16.4309C11.9449 16.4309 15.3663 10.9599 24.42 13.3772C24.42 13.3772 31.1373 15.5099 31.5754 23.6147",
    stroke: "#236AC9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93176 24.4536C1.93176 24.4536 1.90706 38.5172 14.4899 42.3286C14.4899 42.3286 27.8882 45.8929 34.2035 35.3277L38 37.2641L34.9335 26.8369L25.1982 30.2916L27.987 31.9795C27.987 31.9795 24.5656 37.711 15.512 35.1786C15.512 35.1786 8.79478 32.9444 8.35666 24.4536",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93176 24.4536C1.93176 24.4536 1.90706 38.5172 14.4899 42.3286C14.4899 42.3286 27.8882 45.8929 34.2035 35.3277L38 37.2641L34.9335 26.8369L25.1982 30.2916L27.987 31.9795C27.987 31.9795 24.5656 37.711 15.512 35.1786C15.512 35.1786 8.79478 32.9444 8.35666 24.4536",
    stroke: "#2EA76D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackupcodes);
export default __webpack_public_path__ + "static/media/backupcodes.5bb65d3fd47cfb919b1f23f5102c5b11.svg";
export { ForwardRef as ReactComponent };